import { motion, useInView } from "framer-motion";
import { useRef } from "react";

interface ServiceCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const ServiceCard = ({ icon, title, description }: ServiceCardProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 100 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 1, ease: "easeOut" }}
      className='flex flex-col items-center text-center p-6 border-r border-gray-100 last:border-r-0'
    >
      <div className='mb-4'>{icon}</div>
      <h3 className='text-teal-500 font-medium mb-2'>{title}</h3>
      <p className='text-gray-500 text-sm'>{description}</p>
    </motion.div>
  );
};


export default ServiceCard